<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
    <notification-popup></notification-popup>
    <vx-tour :steps="steps" v-if="!disableThemeTour && (windowWidth >= 1200 && mainLayoutType === 'vertical' && verticalNavMenuWidth == 'default')" />

    <v-nav-menu
      :navMenuItems = "navMenuItems"
      :title        = "appTitle"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>

      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />
    </template>

    <template v-else-if="windowWidth < 1200">
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div
        class="content-wrapper"
        :class="{
          'mt-16': windowWidth < 1200
        }"
      >

        <div
          class="router-view"
          :class="{ 'pb-0': routeTitle === 'Atendimento' }"
        >
          <div class="router-content">

            <transition :name="routerTransition">

              <div
                v-if="($route.meta.breadcrumb || $route.meta.pageTitle) && routeTitle !== 'Atendimento'"
                class="router-header flex flex-wrap items-center mb-6"
              >
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle=='Atendimento'?`${routeTitle} ${ activeChatUser}`: routeTitle }} </h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />
              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>

              <contract-popup />
            </div>
          </div>
        </div>
      </div>
      <the-footer v-if="routeTitle !== 'Atendimento'" />
    </div>

    <vs-popup
      title="Transferência de atendimento"
      :active.sync="ticketTransferPopup"
      v-if="ticketTransfer"
    >
      <div class="text-center">
        <vs-row class="mt-2">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <span>
              <span color="text-primary">{{ ticketTransfer.next_user_name }}</span>
               pediu o atendimento de 
              <span color="text-primary">
                {{ ticketTransfer.customer_name }} {{ ticketTransfer.customer_phone_number }}
              </span>
                na conexão
              <span color="text-primary">{{ ticketTransfer.instance_name }}</span>
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mt-2">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
            <span>
              Se não houver resposta em
              <vue-countdown :time="timer" v-slot="{ minutes, seconds }">
                 <span class="text-primary"> {{ minutes }}:{{ seconds }}</span>
              </vue-countdown>
              o atendimento será transferido automaticamente.
            </span>
          </vs-col>
        </vs-row>
        <vs-row class="mt-4 mb-4">
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-button
              class="ticket-transfer-span"
              @click.prevent="refuseTicketTransfer"
            >
              <span>
                NEGAR
              </span>
            </vs-button>
          </vs-col>
          <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="6">
            <vs-button
              class="ticket-transfer-span"
              @click.prevent="confirmTicketTransfer"
            >
              <span>
                ACEITAR
              </span>
            </vs-button>
          </vs-col>
        </vs-row>
      </div>
    </vs-popup>
    <ButtonFloating v-if="!disablePedbotReferences" />
  </div>
</template>


<script>
import BackToTop            from 'vue-backtotop'
import HNavMenu             from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import TheNavbarHorizontal  from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical    from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter            from '@/layouts/components/TheFooter.vue'
import themeConfig          from '@/../themeConfig.js'
import VNavMenu             from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import ContractPopup        from '@/layouts/components/contract-popup/ContractPopup.vue'
import moduleLayout         from '@/store/layout/moduleLayout'
import moduleChatContact    from '@/store/chatContact/moduleChatContact'
import ButtonFloating       from '@/components/button/ButtonFloating'
import NotificationPopup    from '@/layouts/components/notification-popup/NotificationPopup.vue'

const VxTour = () => import('@/components/VxTour.vue')

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    VxTour,
    ContractPopup,
    ButtonFloating,
    NotificationPopup,
  },
  data() {
    return {
      disableThemeTour  : themeConfig.disableThemeTour,
      dynamicWatchers   : {},
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      steps: [{
          target  : '#btnVNavMenuMinToggler',
          content : 'Toggle Collapse Sidebar.'
        },
        {
          target  : '.vx-navbar__starred-pages',
          content : 'Create your own bookmarks. You can also re-arrange them using drag & drop.'
        },
        {
          target  : '.i18n-locale',
          content : 'You can change language from here.'
        },
        {
          target  : '.navbar-fuzzy-search',
          content : 'Try fuzzy search to visit pages in flash.'
        },
        {
          target  : '.vs-button.buy-now',
          content : 'Buy this awesomeness at affordable price!',
          params  : {
            placement: 'top'
          }
        },
      ],
      ticketTransferPopup: false,
      ticketTransfer: null,
      timer: 0,
      hiddenButtonFloating: false
    }
  },
  watch: {
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
      this.updateNavbarColor(color)
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val)
      this.disableThemeTour = true
    }
  },
  computed: {
    disablePedbotReferences() {
      if (!this.hiddenButtonFloating) {
        return process.env.VUE_APP_DISABLE_PEDBOT_REFERENCES === 'true'
      } else {
        return process.env.VUE_APP_DISABLE_PEDBOT_REFERENCES === 'false'
      }
    },
    appTitle() {
      return process.env.VUE_APP_APP_TITLE;
    },
    activeChatUser() {       
      return this.$store.state.activeChatUser ? `- ${this.$store.state.activeChatUser}`:'';    
    },
    bodyOverlay() { return this.$store.state.bodyOverlay },
    contentAreaClass() {
      if(this.mainLayoutType === "vertical") {
        if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
        else return "content-area-full"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark()     { return this.$store.state.theme == 'dark' },
    layoutTypeClass() { return `main-${this.mainLayoutType}` },
    mainLayoutType()  { return this.$store.state.mainLayoutType  },
    navbarClasses()   {
      return {
        'navbar-hidden'   : this.navbarType == 'hidden',
        'navbar-sticky'   : this.navbarType == 'sticky',
        'navbar-static'   : this.navbarType == 'static',
        'navbar-floating' : this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
    windowWidth()          { return this.$store.state.windowWidth },
    navMenuItems() { return this.$store.state.layout.navMenuItems || [] }
  },
  methods: {
    refuseTicketTransfer() {
      this.$store.dispatch('ticketTransfer/deleteTicketTransfer', this.ticketTransfer.id).then(() => {
        this.ticketTransferPopup = false
      }).catch((error) => {
        console.log(error)
      })
    },
    confirmTicketTransfer() {
      this.$store.dispatch('ticketTransfer/confirmTicketTransfer', this.ticketTransfer.id).then(() => {
        this.ticketTransferPopup = false
      }).catch((error) => {
        console.log(error)
      })
    },
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbar(val) {
      if (val == "static") this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff")
      this.navbarType = val
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter(val) {
      this.footerType = val
    },
    updateRouterTransition(val) {
      this.routerTransition = val
    },
    setNavMenuVisibility(layoutType) {
      if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      }
      else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    },
    updateTimer() {
      if (this.ticketTransfer) {
        if (this.ticketTransfer) {
        let d1 = new Date(new Date(this.ticketTransfer.transfer_at).toUTCString())
        let d2 = new Date(new Date().toUTCString())
        this.timer = d1 - d2
      }
      }

      return 0
    }
  },
  created() {
    if (!moduleLayout.isRegistered) {
      this.$store.registerModule('layout', moduleLayout)
      moduleLayout.isRegistered = true
    }

    if (!moduleChatContact.isRegistered) {
      this.$store.registerModule('chatContact', moduleChatContact)
      moduleChatContact.isRegistered = true
    }

    this.$store.dispatch("layout/navMenuItems")
    this.$store.dispatch("chatContact/socketListeners")
    this.$store.dispatch("internalChatMessages/socketListeners")

    const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)

    // Dynamic Watchers for tour
    // Reason: Once tour is disabled it is not required to enable it.
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch("$store.state.windowWidth", (val) => {
      if(val < 1200) {
        this.disableThemeTour = true
        this.dynamicWatchers.windowWidth()
      }
    })

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch("$store.state.verticalNavMenuWidth", () => {
      this.disableThemeTour = true
      this.dynamicWatchers.verticalNavMenuWidth()
    })

    this.dynamicWatchers.rtl = this.$watch("$vs.rtl", () => {
      this.disableThemeTour = true
      this.dynamicWatchers.rtl()
    })

    this.$events.on('ChatTicketTransferTimerAllPages', async (ticketTransfer) => {
      this.ticketTransfer = ticketTransfer
      this.updateTimer()
      await new Promise(resolve => setTimeout(resolve, 800));
      this.ticketTransferPopup = true
    })

    this.$events.off('SetButtonFloating')
    this.$events.on('SetButtonFloating', (event) => {
      this.hiddenButtonFloating = event;
    })
  },
  beforeDestroy() {
    Object.keys(this.dynamicWatchers).map(i => {
      this.dynamicWatchers[i]()
      delete this.dynamicWatchers[i]
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$events.fire('closeInternalChatMessageComponents', false);
    setTimeout( ()=> {
      this.$events.fire('closeInternalChatMessageComponents', false);
      next();
    }, 1);
  },
}

</script>

